import { useMemo } from 'react';
import { useEnabledRetailers } from '../FeatureFlags';
import { ALL_STORES } from '../config/retailers';
import type { StoreConfig } from '../modules/Config';
import { useInitialParamsSnapshot } from './useInitialParams';

export function useRetailerOptions(): StoreConfig[] {
  const { region, storeFilter, token } = useInitialParamsSnapshot();
  const enabledRetailers = useEnabledRetailers();

  return useMemo(() => {
    const visible = ALL_STORES.filter(
      (o) =>
        enabledRetailers.includes(o.retailer_key) ||
        (o.dev_only && storeFilter.includes(o.retailer_key))
    );
    if (storeFilter.length > 0) {
      const filtered = visible.filter((o) =>
        storeFilter.includes(o.retailer_key)
      );
      return filtered.length > 0 ? filtered : visible;
    }
    if (token) {
      const amazonOnly = visible.filter((o) => o.retailer_id === 'amazon');
      if (amazonOnly.length > 0) return amazonOnly;
    }
    return visible;
    // oxlint-disable-next-line react/exhaustive-deps
  }, [enabledRetailers, storeFilter, token, region]);
}
